// 書籍、評論、特輯連載頁面
import axios from 'axios'
import {API_URL} from './config.js'

export default {
 //0918火力修改
 getCartList: function () {
  return new Promise((resolve, reject) => {
    axios.get(`${API_URL}/ShoppingCart/List`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      response.data.Books.length===0 ? document.getElementById("cart_product_empty").innerHTML="購物車內尚無商品" : ""
      response.data.Books.map(book => {
        book.checked = false
      })
      response.data.selectedAll = false
      this.cartList = response.data || []
      resolve(response)
    }).catch(e => {
      document.getElementById("cart_product_empty").innerHTML=""
      console.log(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      reject(e)
    })
  })
},
  // 0918火力新增function
  addCartItems: function () {
    // console.log('test')
    if (!this.isLogin) {
      alert(`請先登入！`)
      return false
    }
    if (this.selectedBookVols.length) {
      this.selectedBookVols.map(book => {
        this.addCartItem(book.BookID)
        // alert(`加入 ${book.BookID} 到購物車!`)
      })
    } else {
      alert('尚未選擇書籍')
    }
  },
  addCartItem: function (BookID) {
    console.log('addCartItem')
    let params = {
      BookID: BookID
    }
    axios.put(`${API_URL}/ShoppingCart/${this.getParams(params, false)}`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
      alert(`加入到購物車!`)
      // if (response.data.Succeeded) alert('加入成功!')
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      alert(`加入失敗: ${e.response.data.Errors[0].Message}`)
    })
  },
  removeCartItem: function (BookID = '387a0cb3-324f-46e6-347e-08d5cacfb51c') {
    return new Promise((resolve, reject) => {
      let params = {
        BookID: BookID
      }
      axios.delete(`${API_URL}/ShoppingCart/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
        // alert('刪除成功!')
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
        alert('刪除失敗')
        reject(e)
      })
    })
  },
  getPurchase: function () {
    axios.get(`${API_URL}/ShoppingCart/Purchase`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // this.goToNextCart(this.cartStatus.step3)
      if (response.data) {
        console.log('subscribe/added')
        this.cartFinish = response.data
        this.getUserWallet()
        this.goToNextCart(this.cartStatus.step3)
      } else {
        alert(`${response.data.Errors[0].Message}`)
        this.redirectTo('/')
      }
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  purchase: function (BookIDs) {
    return new Promise((resolve, reject) => {
      let params = {
        BookIDs: ['387a0cb3-324f-46e6-347e-08d5cacfb51c']
      }
      axios.post(`${API_URL}/ShoppingCart/Purchases`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
        reject(e)
      })
    })
  },
  //0918火力修改
  quickPurchase: function (BookID = '') {
    let thisItem = this
    let params = {
      BookID: BookID
    }
    axios.post(`${API_URL}/ShoppingCart/QuickPurchase`, this.$root.getBodyFormData(params), this.$root.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      alert("購買成功")
      // window.location.href.substr(0, window.location.href.indexOf('#'))
      // $(".remodal-overlay.remodal-is-opened").removeClass("remodal-is-opened").addClass("remodal-is-closed").hide()
      // $(".remodal-wrapper.remodal-is-opened").removeClass("remodal-is-opened").addClass("remodal-is-closed").hide()
      
      axios.get(`${API_URL}/Account/Wallet`, thisItem.$root.getBearerToken()).then(response => {
        $(".donli_coin_head>.bonuspoint").text(response.data.Bonus_Coin)
        $(".donli_coin_head>.donli_coin").text(response.data.TongLi_Coin)
      }).catch(e => {
        console.log(e)
      })

      // window.location.href = '/cart?status=success&coin=100'
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      if (e.response.data.Errors) {
        alert(`快速購買失敗: ${e.response.data.Errors[0].Message}`)
      } else {
        alert(`快速購買失敗: 請登入已進行購買`)
      }
    })
  },
  //打包購買改寫
  getBookGroupPurchases: function (BookGroupID) {
    $.ajaxSetup({
      headers:{ 'Authorization': "Bearer " + this.getToken()},
    });
    $.post(API_URL+"/ShoppingCart/AddBookGroup/"+BookGroupID,function(response){
      alert("套書已加入購物車")
    }).fail(function(data) {
      alert("套書加入購物車失敗")
  });

  },
  getDenomination: function () {
    axios.get(`${API_URL}/Deposit/GetDenomination`, this.getBearerToken()).then(response => {
      this.denominations = response.data
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  createOrder: function (denominationID) {
    return new Promise((resolve, reject) => {
      let params = {
        denominationID: denominationID,
        depositDevice:0 //Web = 0
      }
      axios.post(`${API_URL}/Deposit/CreateOrder`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
        resolve(response)
      }).catch(e => {
        console.log(e)
        reject(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      })
    })
  },
  //10/1改寫
  ecpay: function (uri, postData, postModel) { 
    $.ajax({
      url:uri,
      method:'post',
      crossDomain: true,
      data:postData+"&EncryptType=1",
      dataType: 'json',
      success:function(res){
        var w = window.open('about:blank');
        w.document.open();
        w.document.write(res);
        w.document.close();
      },
      error:function(xhr,ajaxOptions,throwError){
        console.log(xhr)
      }
    })
  },
  checkReceiptWithAppStore: function (receiptData) {
    let params = {
      receiptData: receiptData
    }
    axios.get(`${API_URL}/Deposit/CheckReceiptWithAppStore`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  // 新增購物車項目
  addOrderCartItem: function () {
    // this.confirmCartList.push
    console.log('addOrderCartItem')
  },
  // 刪除購物車項目
  removeOrderCartItem: function (idx) {
    return new Promise((resolve, reject) => {
      let price = this.cartList.Books[idx].BookPrice.Price
      let bouns = this.cartList.Books[idx].BookPrice.Bonus
      this.removeCartItem(this.cartList.Books[idx].BookID).then(response => {
        this.cartList.Books.splice(idx, 1)
        this.cartList.TotalPrice -= price
        this.cartList.TotalBonus -= bouns
        this.getCartList()
        resolve(response)
      }).catch(e => {
        console.log(e)
        reject(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      })
    })
  },
  // 新增確認列表刪除
  addRemoveCartItemList: function (book) {
    console.log('addRemoveCartItemList')
    book.checked = true
  },
  removeCartItemList: function (book) {
    console.log('removeCartItemList')
    book.checked = false
  },
  // 刪除確認列表
  removeOrderCartItems: function (idxs) {
    console.log('removeOrderCartItems')
    console.log(idxs)
    idxs.map(idx => this.cartList.splice(idx, 1))
  },
  removeSelectedCartItems: function () { 
    console.log('removeSelectedCartItems')
    this.cartList.Books.map((book, idx) => {
      if (book.checked) {
        this.removeOrderCartItem(idx)
      }
    })
    alert("刪除成功!")
    this.cartList.selectedAll = false
    this.cartActions.selected = []
  },
  selectAllCart: function () {
    console.log('selectAllCart')
  },
  selectAllItems: function () {
    console.log('selectAllItems')
    if (typeof this.cartList.selectedAll === 'undefined') {
      this.cartList.selectedAll = false
    }
    this.cartList.Books.map(book => {
      if (!this.cartList.selectedAll) {
        this.addRemoveCartItemList(book)
      } else {
        this.removeCartItemList(book)
      }
    })
    if (!this.cartList.selectedAll) {
      this.cartList.selectedAll = true
    } else {
      this.cartList.selectedAll = false
    }
  },
  goToNextCart: function (stage) {
    console.log('goToNextCart')
    if (stage !== this.cartStatus.step3) this.cartList.Books = []
    if (stage === this.cartStatus.step2) {
      this.getCartList()
    }
    this.cartStage = stage
  },
  bookCheck: function (book) {
    console.log(this.cartList.Books)
    console.log(book.checked)
  },
  goPurchase: function (bookIds) {
    this.purchase(bookIds).then(response => {
      this.goToNextCart(this.cartStatus.step3)
    })
  },
  backToCart: function () {
    console.log('backToCart')
    if (this.cartStage === this.cartStatus.step2) {
      this.cartStage = this.cartStatus.step1
    } else {
      console.log('cant go back becoz you are not in stage2')
    }
  },
  redirectToPay:function(selectedDen){
    if(selectedDen){
      this.redirectTo('/ECPay?selectedDen='+selectedDen)
    }else{
      alert("請選擇儲值金額")
    }
  }
}



// WEBPACK FOOTER //
// ./src/cart.js